/**
 * Shifts a `position: fixed` or absolutely positioned element by just enough to keep it inside the
 * viewport, never past the top or left edge. Any shift from a previous call is dropped first, so
 * it can run again whenever the element moves or resizes.
 */
export function fitIntoViewport(
  element: HTMLElement,
  axes: 'both' | 'vertical' = 'both'
): void {
  // With a transition on `transform`, the box would be measured mid-animation rather than at
  // its resting place, so the shift is computed and applied with transitions off.
  const transition = element.style.transition;
  element.style.transition = 'none';
  element.style.transform = '';
  const rect = element.getBoundingClientRect();
  const dy = overshoot(rect.top, rect.bottom, window.innerHeight);
  const dx = axes === 'both' ? overshoot(rect.left, rect.right, window.innerWidth) : 0;
  if (dx > 0 || dy > 0) {
    element.style.transform = `translate(-${dx}px, -${dy}px)`;
  }
  // Commits the shift before transitions come back, so it is not animated either.
  element.getBoundingClientRect();
  element.style.transition = transition;
}

function overshoot(start: number, end: number, limit: number): number {
  return Math.max(0, Math.min(end - limit, start));
}
